import { useState } from "react"

export const useVerifyEmail = (email: string) => {
  const [isVerifying, setIsVerifying] = useState(false)

  const verifyEmail = async () => {
    setIsVerifying(true)

    try {
      await fetch(
        App.api.verifyEmail(email, "json", "mds"),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    } catch (error) {
      App.displayFlash("danger", "Failed to verify email")
    } finally {
      setIsVerifying(false)
    }
  }

  return { isVerifying, verifyEmail }
}
